module.exports = __webpack_public_path__ + "img/photo-image.da37fcaf.svg";